import Repository from './Repository';

const resource = '/posts';

export default {
    get(payload)        {return Repository.get(`${resource}`, payload);},
    show(id)            {return Repository.get(`${resource}/${id}`);},
    create(payload)     {return Repository.post(`${resource}`, payload);},
    update(payload, id) {return Repository.post(`${resource}/${id}`, payload);},
    delete(id)          {return Repository.delete(`${resource}/${id}`);},
    addView(id)         {return Repository.post(`${resource}/addView/${id}`);},
}